import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "./styles/tokens.css";

const container = document.getElementById("root");
if (!container) throw new Error("missing #root");

createRoot(container).render(
  <StrictMode>
    {/* Real URLs per view, so a conversation or a collection can be linked,
        reloaded and reached with the browser's back button. nginx falls back to
        index.html for any unknown path, which is what makes a deep link work on
        a hard reload. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
